import React from "react";
import styled from "@emotion/styled";

import mediaqueries from "@styles/media";

import { Icon } from '@types';


const Logo: Icon = ({ fill = "white" }) => {
  return (
    <LogoContainer>
      <svg width="44" height="56" viewBox="0 0 176 224" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M159.346 224C156.841 223.998 154.369 223.431 152.114 222.34C149.858 221.249 147.877 219.662 146.318 217.698C141.494 212.479 104.211 175.788 81.365 153.418C79.7839 151.891 78.5199 150.066 77.6458 148.047C76.7718 146.029 76.3049 143.857 76.2721 141.657C76.2394 139.457 76.6413 137.272 77.4548 135.228C78.2684 133.184 79.4775 131.322 81.0124 129.748C82.5473 128.175 84.3778 126.921 86.3984 126.059C88.419 125.197 90.5898 124.745 92.7858 124.727C94.9818 124.709 97.1596 125.127 99.1937 125.956C101.228 126.786 103.078 128.01 104.638 129.559C104.801 129.719 121.255 145.832 137.586 161.928L142.703 166.973V88.6212C142.703 58.151 118.164 33.3614 88 33.3614C57.8361 33.3614 33.2973 58.151 33.2973 88.6212V207.318C33.2973 211.742 31.5432 215.985 28.421 219.113C25.2988 222.241 21.0641 223.998 16.6486 223.998C12.2331 223.998 7.9985 222.241 4.87627 219.113C1.75405 215.985 0 211.742 0 207.318V88.6212C0 39.755 39.4765 0 88 0C136.523 0 176 39.755 176 88.6212V207.318C175.998 211.742 174.243 215.985 171.12 219.114C167.997 222.242 163.762 223.999 159.346 224ZM144.21 214.249L144.217 214.264L144.21 214.249Z" fill="url(#paint0_linear)"/>
      <path d="M88.001 104.655C98.5095 104.655 107.028 96.1202 107.028 85.5914C107.028 75.0627 98.5095 66.5275 88.001 66.5275C77.4925 66.5275 68.9737 75.0627 68.9737 85.5914C68.9737 96.1202 77.4925 104.655 88.001 104.655Z" fill="url(#paint1_linear)"/>
      <defs>
      <linearGradient id="paint0_linear" x1="88" y1="226.688" x2="88" y2="0.671991" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C0F4"/>
      <stop offset="1" stop-color="#12ECA0"/>
      </linearGradient>
      <linearGradient id="paint1_linear" x1="88.001" y1="226.627" x2="88.001" y2="0.64242" gradientUnits="userSpaceOnUse">
      <stop stop-color="#00C0F4"/>
      <stop offset="1" stop-color="#12ECA0"/>
      </linearGradient>
      </defs>
      </svg>

    </LogoContainer>
  );
};

export default Logo;

const LogoContainer = styled.div`
  .Logo__Mobile {
    display: none;
    
  }
  p{
    font-family: 'Solway', serif;
  }
  ${mediaqueries.tablet`
    .Logo__Desktop {
      display: none;
    }
    
    .Logo__Mobile{
      display: block;
    }
  `}
`;
